import { render, staticRenderFns } from "./NotificacioncontactoForm.vue?vue&type=template&id=07c93cc5"
import script from "./NotificacioncontactoForm.vue?vue&type=script&lang=js"
export * from "./NotificacioncontactoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports